import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useThemeColor } from "./useThemeColor.js";
const CancelIcon = forwardRef(
  ({ backgroundColor: propBackgroundColor = "transparent", ...props }, ref) => {
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26", children: /* @__PURE__ */ jsx("g", { id: "Group_13563", "data-name": "Group 13563", transform: "translate(-309 -298.001)", children: /* @__PURE__ */ jsx("g", { id: "Group_13565", "data-name": "Group 13565", children: /* @__PURE__ */ jsxs("g", { id: "Group_13567", "data-name": "Group 13567", children: [
      /* @__PURE__ */ jsx("g", { id: "Group_13209", "data-name": "Group 13209", transform: "translate(267.568 -419.156)", children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "Path_15781",
          "data-name": "Path 15781",
          fill: backgroundColor,
          d: "M13,0A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z",
          transform: "translate(41.432 717.157)"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { id: "cancel_close", "data-name": "cancel/close", transform: "translate(317.598 306.692)", children: /* @__PURE__ */ jsx("g", { id: "Group_418", "data-name": "Group 418", children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "Path_435",
          "data-name": "Path 435",
          fill: backgroundColor,
          stroke: "currentColor",
          d: "M4.919,4.406,8.693.631A.367.367,0,1,0,8.184.1L8.175.112,4.4,3.887.626.112A.367.367,0,0,0,.107.631L3.882,4.406.107,8.18A.367.367,0,0,0,.626,8.7L4.4,4.924,8.175,8.7a.367.367,0,0,0,.519-.519Z",
          transform: "translate(0 0)"
        }
      ) }) })
    ] }) }) }) }) });
  }
);
export {
  CancelIcon
};
//# sourceMappingURL=CancelIcon.js.map
